(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-topbar-message"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-topbar-message]').forEach((topbar) => {
      const btn = topbar.querySelector('[data-btn-close]');

      btn?.addEventListener('click', () => {
        topbar.style.display = 'none';
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
